import Fluxible from 'fluxible';
import devToolsPlugin from 'fluxible-plugin-devtools';

import Index from './scripts/components/application';
import RouteStore from './scripts/stores/route';

import './scripts/utils/polyfills';
import { LegacyNavigationStore } from 'app/scripts/stores/legacy-navigation-store';

// create new fluxible instance
var app = new Fluxible({
  component: Index
});

// register stores
app.registerStore(RouteStore);
app.registerStore(LegacyNavigationStore);

if (process.env.NODE_ENV !== 'production') {
  app.plug(devToolsPlugin());
}

export default app;
